export const errorStyle = {
  position    : 'absolute',
  whiteSpace  : 'nowrap',
  overflow    : 'hidden',
  textOverflow: 'ellipsis',
  bottom      : -6,
  fontSize    : 12,
  width       : '100%'
};
export const textStyle = {
  fontFamily: 'open sans',
  color: 'black'
};
export const underlineStyle = {
  borderColor: 'black'
}


// WEBPACK FOOTER //
// ./registration-react/styles.js